import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Input,
  CardHeader,
  Button,
  ButtonGroup,
} from "reactstrap";
import DataTable from "react-data-table-component";
import Select from "react-select";
import userDataList from "./data/data";
import Flatpickr from "react-flatpickr";
import AddUserModal from "./modal/AddUserModal";
import CoopUserService from "../../services/CoopUserService/CoopUserService";
import DeleteModal from "./modal/DeleteModal";
import toast from "react-hot-toast";
import { Search } from "feather-icons-react/build/IconComponents";

const UserManagementList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [filterText, setFilterText] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [dateRange, setDateRange] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [selectedUser, setSelectedUser] = useState();
  const [modal, setModal] = useState(false);
  const [isDeleteOpen, setIsDeleteOpen] = useState(false);

  const toggleModal = () => setModal(!modal);
  const handleDeleteToggle = () => setIsDeleteOpen(!isDeleteOpen);

  const fetchData = async () => {
    try {
      const fetchData = await CoopUserService.get();
      console.log("fetchData", fetchData);
      setData(fetchData.data);
      setFilteredData(fetchData.data);
    } catch (err) {
      console.log("🚀 ~ fetchData ~ error:", err);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    applyFilters();
  }, [searchQuery]); //[searchQuery, selectedReport, dateRange]);

  const applyFilters = () => {
    let filtered = [...data];
    console.log("filtered", filtered);

    // Apply search filter
    if (searchQuery !== "") {
      filtered = filtered.filter((item) =>
        item.userName.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // // Apply reporting type filter
    // if (selectedReport) {
    //   filtered = filtered.filter(
    //     (item) => item.reportingBasis === selectedReport.value
    //   );
    // }

    // // Apply date range filter
    // if (dateRange.length === 2) {
    //   const [startDate, endDate] = dateRange;
    //   filtered = filtered.filter((item) => {
    //     const itemDate = new Date(item.loanMaturityDate);
    //     return itemDate >= startDate && itemDate <= endDate;
    //   });
    // }

    setFilteredData(filtered);
  };

  const fetchUserType = async () => {
    try {
      const response = await CoopUserService.getList({
        pageNumber: 1,
        pageSize: 200,
      });
      setUser(response.data);
    } catch (error) {
      console.log("🚀 ~ fetchUserType ~ error:", error);
    } finally {
    }
  };

  const handleDelete = async () => {
    try {
      const response = await CoopUserService.delete(selectedUser.id);
      toast.success("User is Deleted Successfully!");
      fetchData();
      setSelectedUser(null); // Reset selectedUser to null
      handleDeleteToggle();
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
    }
  };

  const customStyles = {
    headCells: {
      style: {
        fontSize: "0.92rem",
        fontWeight: 610,
      },
    },
    rows: {
      style: {
        fontSize: "0.9rem",
      },
    },
  };

  const columns = [
    {
      name: "S.N",
      selector: (row) => row.sn,
      sortable: true,
      width: "80px",
    },
    {
      name: "Name",
      selector: (row) => row.userName,
      sortable: true,
    },
    {
      name: "Email",
      selector: (row) => (row.email ? row.email : "No data available"),
      sortable: true,
    },
    // {
    //   name: "Department",
    //   selector: (row) =>
    //     row.department ? row.department : "No data available",

    //   sortable: true,
    // },
    {
      name: "Phone",
      selector: (row) => (row.phone ? row.phone : "No data available"),
      sortable: true,
    },
    // {
    //   name: "Role",
    //   selector: (row) => (row.role ? row.role : "No data available"),
    //   sortable: true,
    // },
    {
      name: "Action",
      selector: (row) => row.action,
    },
  ];

  console.log("filteredData:", filteredData);

  const dataRows = filteredData?.map((item, index) => ({
    sn: index + 1,
    firstName: item.firstName,
    lastName: item.lastName,
    userName: (
      <Link to={`/user-management/user-detail/${item.id}`}>
        {item.userName}
      </Link>
    ),
    email: item.email,
    department: item.department,
    phone: item.phone,
    role: item.roles,
    action: (
      <ButtonGroup size="sm">
        <div className="d-flex gap-1">
          <Button
            title="Edit"
            color="btn btn-soft-warning"
            className="rounded-circle btn-sm gap-1"
            onClick={() => {
              setSelectedUser(item);
              toggleModal();
            }}
          >
            <i className="ri-edit-line"></i>
          </Button>
          <Button
            title="Delete"
            className="rounded-circle btn btn-soft-danger btn-sm gap-1"
            color="danger"
            onClick={() => {
              // handleDeleteModal();
              setSelectedUser(item);
              handleDeleteToggle();
            }}
          >
            <i className="ri-delete-bin-2-line"></i>
          </Button>
        </div>
      </ButtonGroup>
    ),
  }));
  console.log("selected user", selectedUser);
  return (
    <Container fluid>
      <div className="page-content">
        <Row>
          <Col xs={6} className="mb-0">
            <h5>
              <span className=" px-1 ">User Management</span>
            </h5>
          </Col>
          <Col lg={6} className="text-end">
            <Button
              color="success"
              onClick={toggleModal}
              // onClick={() => {
              //   navigate("/newspaper/add");
              // }}
              className=" text-end mb-2"
            >
              <i className="ri-add-line align-bottom"></i>
              Add New User
            </Button>
          </Col>
        </Row>
        <Row className="gap-0 mb-2">
          <Col xs={3}>
            <div className="search-box ">
              <input
                type="text"
                className="form-control search"
                placeholder="Search by username"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <i className="ri-search-line search-icon"></i>
            </div>
          </Col>
          {/* <Col xs={3}>
            <div className=" ">
              <Flatpickr
                className="form-control"
                id="datepicker-publish-input"
                placeholder="Select a range of date"
                options={{
                  altInput: true,
                  altFormat: "F j, Y",
                  mode: "range",
                  dateFormat: "d.m.y",
                }}
                value={dateRange}
                onChange={(dates) => setDateRange(dates)}
              />
            </div>
          </Col> */}
          {/* <Col xs={3}>
            <div className="search-box ">
              <Select
                isClearable={true}
                placeholder="Select by reporting type"
                options={[
                  { value: "DueIntrest", label: "Due Interest" },
                  { value: "DueInstallment", label: "Due Installment" },
                  { value: "LoanOverDue", label: "Loan Overdue" },
                ]}
                value={selectedReport}
                onChange={setSelectedReport}
              />
            </div>
          </Col> */}
        </Row>
        <DataTable
          responsive
          striped
          pagination
          highlightOnHover
          pointerOnHover
          persistTableHead
          customStyles={customStyles}
          columns={columns}
          data={dataRows}
        />
        <AddUserModal
          isOpen={modal}
          toggle={toggleModal}
          selectedUser={selectedUser}
          fetchUserType={fetchData}
          setSelectedUser={setSelectedUser}
        />
        <DeleteModal
          deleteTerm={"User"}
          handleDelete={handleDelete}
          isOpen={isDeleteOpen}
          toggle={handleDeleteToggle}
        />
      </div>
    </Container>
  );
};

export default UserManagementList;
